import React, {Component} from 'react';
import EventUtils from '../../utils/EventUtils';
import './ReportSection.css';

class ReportSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reportName: this.props.selected
        }
    }

    componentDidMount() {
        this._handleOnChange();
    }

    get reportName() {
        return this.state.reportName;
    }

    set reportName(reportName) {
        this.setState({reportName: reportName});
    }

    async _handleOnChange(event) {
        if (event) {
            let option = event.target;
            await this.setState({reportName: option.value});
        }
        if (this.reportName) {
            EventUtils.raiseEvent('change', this.reportName, this.props);
        }
    }

    render() {
        return (
            <div>
                <h6 className="title">Job Type</h6>
                <div className="row" id="report-selection">
                    {
                        this
                            .props
                            .options
                            .map((option, index) => (
                                <div key={index} className="col s6">
                                    <label>
                                        <input
                                            type="radio"
                                            name="report"
                                            className="with-gap"
                                            defaultChecked={this.props.selected === option.label}
                                            onChange={this
                                                ._handleOnChange
                                                .bind(this)}
                                            value={option.value}/>
                                        <span>{option.label}</span>
                                    </label>
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

export default ReportSection;